var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from '~/config/server';
import { NetService } from '~/utils/net.service';
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var ImportDataExcelRecordService = /** @class */ (function (_super) {
    __extends(ImportDataExcelRecordService, _super);
    function ImportDataExcelRecordService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 获取未确认的批次号
     */
    ImportDataExcelRecordService.prototype.getImportDataExcelBatchNumber = function (loading) {
        return this.netService.send({
            server: dataimpService.importDataExcelRecordController.getImportDataExcelBatchNumber,
            loading: loading
        });
    };
    /**
     * 查询导入结果
     */
    ImportDataExcelRecordService.prototype.getImportDataExcelList = function (data, page, sort, loading) {
        return this.netService.send({
            server: dataimpService.importDataExcelRecordController.getImportDataExcelList,
            data: {
                principalName: data.principalName,
                batchNumber: data.batchNumber,
                importDataExcelStatus: data.importDataExcelStatus //数据导入状态
            },
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 获取未确认的批次号
     */
    ImportDataExcelRecordService.prototype.getImportDataExcelCaseDetail = function (data, loading) {
        return this.netService.send({
            server: dataimpService.importDataExcelRecordController.getImportDataExcelCaseDetail,
            data: {
                personalName: data.personalName,
                certificateNo: data.certificateNo //证件号
            },
            loading: loading
        });
    };
    /**
     * 确认导入
     */
    ImportDataExcelRecordService.prototype.confirmExcelImpCase = function (id, loading) {
        return this.netService.send({
            server: dataimpService.importDataExcelRecordController.confirmExcelImpCase,
            append: [id],
            loading: loading
        });
    };
    /**
     * 查询合并
     * @param data
     * @param page
     * @param sort
     * @param loading
     */
    ImportDataExcelRecordService.prototype.getMergeDataList = function (data, page, sort, loading) {
        return this.netService.send({
            server: dataimpService.importDataExcelRecordController.getMergeDataList,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], ImportDataExcelRecordService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], ImportDataExcelRecordService.prototype, "confirmExcelImpCase", null);
    return ImportDataExcelRecordService;
}(Service));
export { ImportDataExcelRecordService };
